import { useState, useRef } from "react";
import { useMasterLicenseAgreementService } from "@/services";
import { MasterLicenseAgreementItemType } from "@/schemas/index";

export function useLicenseAgreement() {
  const api = useMasterLicenseAgreementService();
  const [mlaItem, setMlaItem] = useState<MasterLicenseAgreementItemType>();
  const [mlaStatus, setMlaStatus] = useState<"init" | "hidden" | "show">(
    "init",
  );

  const currentPromiseFetchInit = useRef<any>();
  const currentPromiseFetchAccept = useRef<any>();

  const fetchLicenseAgreement = () => {
    if (currentPromiseFetchInit.current) {
      return currentPromiseFetchInit.current;
    }

    currentPromiseFetchInit.current = api.fetchStatus();
    currentPromiseFetchInit.current
      .then((acceptMla: boolean) => {
        if (acceptMla) {
          return Promise.resolve();
        }

        return api.fetchItem();
      })
      .then((mlaItem?: MasterLicenseAgreementItemType) => {
        if (mlaItem) {
          setMlaItem(mlaItem);
        }

        setMlaStatus(mlaItem ? "show" : "hidden");
      })
      .finally(() => {
        currentPromiseFetchInit.current = null;
      });

    return currentPromiseFetchInit.current;
  };

  const fetchAcceptLicenseAgreement = () => {
    if (currentPromiseFetchAccept.current) {
      return currentPromiseFetchAccept.current;
    }

    setMlaStatus("hidden");

    currentPromiseFetchAccept.current = api.fetchAccept();
    currentPromiseFetchAccept.current.finally(() => {
      currentPromiseFetchAccept.current = null;
    });

    return currentPromiseFetchAccept.current;
  };

  const fetchSendEmailLicenseAgreement = () => {
    if (currentPromiseFetchAccept.current) {
      return currentPromiseFetchAccept.current;
    }

    return (currentPromiseFetchAccept.current = api.fetchSendEmail());
  };

  return {
    mlaItem,
    mlaStatus,
    fetchLicenseAgreement,
    fetchAcceptLicenseAgreement,
    fetchSendEmailLicenseAgreement,
  };
}
